import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Check, Triangle } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import NotyfContext from '../../contexts/NotyfContext';
import { blankClearReportData, blankCurrentStatus, clearReportData, fetchCurrentStatus, setCurrentStatusApiCall } from '../../redux/slices/DashboardSlice';
import { blankGetAllReportData, getAllReport } from '../../redux/slices/ReportSlice';
import Bear from './summary-bear.svg';
import Bull from './summary-bull.svg';
import Dollar from './summary-dollar.svg';
import Installment from './summary-installment.svg';
import Pages from './summary-pages.svg';
import Star from './summary-star.svg';
import { Link, useNavigate } from 'react-router-dom';
import CurrentProcess from '../../components/charts/CurrentProcess';
import CreditSummary from '../../components/creditSummary/CreditSummary';
import moment from 'moment';
import InfoPopover from '../../components/new/InfoPopover';

import CountdownClock from './Countdown';

import { getScoreColor } from '../../constants';

const Dashboard = () => {
  const [run, setRun] = useState(false);

  const steps = [
    {
      target: '.first-step',
      content: "Here is your progress bar -- you're already on step 2!",
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>And look we're already on a first name basis!</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: 'Open Accounts refers to the total number of active credit accounts you currently have.',
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: 'Negative Accounts are credit accounts with late payments, defaults, or other negative marks on your credit report.',
      disableBeacon: true,
    },
    {
      target: '.fifth-step',
      content: 'Credit Utilization is the percentage of your available credit that you are currently using.',
      disableBeacon: true,
    },
    {
      target: '.sixth-step',
      content: 'Credit Inquiries are the number of times lenders have requested your credit report, which can impact your credit score.',
      disableBeacon: true,
    },
    {
      target: '.seventh-step',
      content: 'Credit History refers to the length of time you have had credit accounts open, which can affect your credit score.',
      disableBeacon: true,
    },
  ];

  useEffect(() => {
    setRun(true);
  }, []);

  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [historyYear, setHistoryYear] = useState(moment().year());

  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const clearReport = useSelector(state => state.dashboard.clearReport);
  const [showLoader, setShowLoader] = useState(false);
  const error = useSelector(state => state.reports.error);
  const roundStartDate = useSelector(state => state.reports.error);

  // let obj = {
  //   1:'/choose-report',
  //   2:'/report-audit',
  //   3:'/verify-info',
  //   4:'/upload-document',
  //   5:'/mailing-option',
  //   6:'/checkout'
  // }

  const getProgressBarWidth = activeStep => {
    switch (activeStep) {
      case 1:
        return '0px';
      case 2:
        return '150px';
      case 3:
        return '310px';
      case 4:
        return '450px';
      case 5:
        return '610px';
      case 6:
        return '760px';
      default:
        return '0px';
    }
  };

  const [currentStatusArr, setCurrentStatusArr] = useState([
    {
      name: 'Account Created',
      active: 0,
      completed: 0,
      link: '',
      number: 1,
    },
    {
      name: 'Upload Reports',
      active: 0,
      completed: 0,
      link: '/report-audit',
      number: 2,
    },
    {
      name: 'Confirm Information',
      active: 0,
      completed: 0,
      link: '/verify-info',
      number: 3,
    },
    {
      name: 'Generate Disputes',
      active: 0,
      completed: 0,
      link: '/upload-document',
      number: 4,
    },
    {
      name: 'Send Disputes',
      active: 0,
      completed: 0,
      link: '/mailing-option',
      number: 5,
    },
    {
      name: 'Disputes In Progress',
      active: 0,
      completed: 0,
      link: '',
      number: 6,
    },
    {
      name: 'Results Generated',
      active: 0,
      completed: 0,
      link: '',
      number: 7,
    },
  ]);
  const activeStep = currentStatusArr.find(step => step.active)?.number ?? 1;
  const currentStatusData = useSelector(state => state.dashboard.currentStatusData);
  const currentApiStatus = useSelector(state => state.dashboard.currentApiStatus);
  const currentStatusError = useSelector(state => state.dashboard.currentStatusError);
  const currentStatusApiCall = useSelector(state => state.dashboard.currentStatusApiCall);

  let cpData = {};

  let clientName = '';
  var creditSummary = {};
  let credit_enhancement_tool = {};
  let currentScores = {
    equifax: 0,
    experian: 0,
    transunion: 0,
    equifaxPresentage: 0,
    experianPresentage: 0,
    transunionPresentage: 0,
    next_update_date: '',
    update_date: '',
  };
  let currentRound = 0;

  // useEffect(() => {
  //   if (reportStatus === 'idle') {
  //     let obj = {
  //       clientId: 1,
  //       roundid: 1,
  //     };
  //     dispatch(getAllReport(obj));
  //   }
  // }, [reportStatus, dispatch]);

  useEffect(() => {
    if (currentApiStatus === 'idle') {
      dispatch(fetchCurrentStatus());
    }
  }, [currentApiStatus, dispatch]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(blankGetAllReportData());
  //   };
  // }, []);

  useEffect(() => {
    if (clearReport && Object.keys(clearReport).length > 0) {
      if (clearReport.error == 0) {
        dispatch(blankClearReportData());
        notyf.open({
          type: 'success',
          message: 'Report clear successfully',
          duration: '1500',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        setTimeout(() => {
          navigate('/choose-report');
        }, 1500);
      } else {
        notyf.open({
          type: 'danger',
          message: clearReport.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [clearReport]);

  const handleClearReport = () => {
    setShowLoader(true);
    dispatch(clearReportData());
    setShowLoader(false);
  };
  useEffect(() => {
    return () => {
      dispatch(setCurrentStatusApiCall(0));
      dispatch(blankCurrentStatus());
    };
  }, []);

  useEffect(() => {
    if (currentStatusData && Object.keys(currentStatusData).length > 0) {
      if (currentStatusData.error === 0 && currentStatusApiCall === 0) {
        // dispatch(blankCurrentStatus())
        dispatch(setCurrentStatusApiCall(1));
        let current_status = currentStatusData.current_status;
        let currentStatusArrOri = [...currentStatusArr];
        //set already active account
        let index = currentStatusArrOri.findIndex(item => item.active === 1);
        if (index !== -1) {
          currentStatusArrOri[index].active = 0;
        }
        //find currentstatus index
        let indexCurrentStatus = currentStatusArrOri.findIndex(item => item.number === current_status);
        if (indexCurrentStatus !== -1) {
          currentStatusArrOri[indexCurrentStatus].active = 1;
        }
        for (let i = 0; i < current_status - 1; i++) {
          currentStatusArrOri[i].completed = 1;
        }
        setCurrentStatusArr(currentStatusArrOri);
      }
    }
  }, [currentStatusData]);

  const handleChartYearChange = year => {
    setHistoryYear(year);
    let obj = {
      clientId: 1,
      roundid: 1,
      round_year: year,
    };
    dispatch(getAllReport(obj));
  };
  

  if (reportStatus === 'loading' || showLoader || currentApiStatus === 'loading') {
    // showNotification()
    return <Loader />;
  } else if (reportStatus === 'succeeded') {
    if (getAllReportData && Object.keys(getAllReportData).length > 0) {
      if (getAllReportData.error == 0) {
        clientName = getAllReportData?.data?.client_name;
        let currentScoresOri = getAllReportData?.data?.current_round_score;
        currentScores.equifax = currentScoresOri.equifax;
        currentScores.experian = currentScoresOri.experian;
        currentScores.transunion = currentScoresOri.transunion;
        currentScores.equifaxPresentage = currentScoresOri.equifax_percentage;
        currentScores.experianPresentage = currentScoresOri.experian_percentage;
        currentScores.transunionPresentage = currentScoresOri.transunion_percentage;
        currentScores.equifax_label = getAllReportData?.data?.scores.equifax_label;
        currentScores.experian_label = getAllReportData?.data?.scores.experian_label;
        currentScores.transunion_label = getAllReportData?.data?.scores.transunion_label;
        currentScores.report_pull_date = currentScoresOri.report_pull_date;
        currentScores.round_end_date = getAllReportData?.data?.round_end_date;

        creditSummary = getAllReportData.data.credit_summary;
        cpData = getAllReportData.data.graph_all_scores;
        credit_enhancement_tool = getAllReportData.data.credit_enhancement_tool;
        currentRound = getAllReportData?.data?.current_round_score.round;
      }
    }
  } else if (reportStatus === 'failed' || currentApiStatus === 'failed') {
    let message = '';
    if (reportStatus === 'failed') {
      message = error;
    } else if (currentApiStatus === 'failed') {
      message = currentStatusError;
    }
    notyf.open({
      type: 'danger',
      message: message,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }
  
  return (
    <React.Fragment>
      <Helmet title='Dashboard' />
      <style>
        {`
            .step-title {
              width: 135px;
            }
            #progress {
              top: 5.25rem;
              left: 94px;
            }
            .active .step-button {
              position: relative;
            }
            .active .step-button::after {
              content: '';
              position: absolute;
              top: -2px;
              left: -5%;
              transform: translate(-50%, -50%);
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background-color: var(--bs-primary);
              animation: sonar 2s infinite;
              z-index: -1;
            }
            @keyframes sonar {
              0% {
                opacity: 1;
                transform: scale(0.5);
              }
              100% {
                opacity: 0;
                transform: scale(1.5);
              }
            }
            .filled {
              fill: currentColor;
            }
            input[type=checkbox] {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border: 2px solid #ccc;
              border-radius: 4px;
              width: 20px;
              height: 20px;
              display: inline-block;
              position: relative;
              vertical-align: middle;
              margin-right: 10px;
              background-color: #7C84A51A;
              border: none;
            }
            input[type=checkbox]:checked:before {
              content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M9.3 17.3l-5-5a1 1 0 0 1 1.4-1.4l4.3 4.3 10-10a1 1 0 0 1 1.4 1.4l-11 11a1 1 0 0 1-1.4 0z' /></svg>");
              display: block;
              position: absolute;
              top: 1px;
              left: 1px;
              color: #fff;
              font-size: 11px;
              width: 16px;
            }
            canvas: {
              box-sizing: initial;
            }

            @media (max-width:991px) {
              #progress-complete {
              width: 280px !important;
            }
             #progress {
              width: 670px !important;
            }
            }

            `}
      </style>
      <Container fluid className='p-0 container-fluid-1335'>
        <Row>
          <Col xs='12'>
            <Button variant='primary' className='position-fixed d-none' style={{ zIndex: 999, right: '284px', top: '60px' }} onClick={() => handleClearReport()}>
              Clear Report
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12' xl='9'>
            <Card className='shadow border-0 p-4 mb-md-0 mb-5'>
              <Card.Body>
                <Row>
                  <Col lg={12} className='first-step mt-3'>
                    <h3>Current status</h3>
                  </Col>

                  <div className='steps w-100 overflow-auto pb-3'>
                    <div id='progress' style={{width: "85%"}}></div>
                    <div id='progress-complete' style={{ top: '5.25rem', width: getProgressBarWidth(activeStep), left: '74px' }}></div>
                    {currentStatusArr?.map((data, key) => {
                      return (
                        <div key={key} className='d-flex flex-row justify-content-between w-100 mb-5 mb-xl-0'>
                          <div className={`step-item ${data.completed ? 'completed' : ''} ${data.active ? 'active' : ''}`}>
                            <div className='step-title' style={{ fontSize: '15px' }}>
                              {data.name}
                            </div>
                            {data.completed ? (
                              <button className='step-button text-white bg-primary border border-primary text-center'>
                                <Check width={15} height={24} strokeWidth={3} />
                              </button>
                            ) : (
                              <button
                                // onClick={() => {
                                //   data.active ? navigate(data.link) : void 0;
                                // }}
                                className={`step-button ${data.active ? 'text-primary bg-light border border-primary border-2' : 'text-secondary bg-light border border-secondary'} text-center`}>
                                {data.number}
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Row>

                <Row className='mb-5'>
                  <div className='mb-3'>
                    <h3 className='mb-0'>Current Scores</h3>
                    <p className='text-muted fw-light fs-sm'>As of {currentScores.report_pull_date && moment(currentScores.report_pull_date).format('MM/DD/YYYY')}</p>
                  </div>

                  <Col xs={12} md={4}>
                    <Card className='border-0 rounded-3 shadow mb-md-0 mb-3'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Equifax</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {currentScores.equifax && currentScores.equifax < 350 ? 'N/A' : currentScores.equifax || 0}
                          </div>
                          {currentRound >= 2 && (
                            <div className={`d-flex my-auto me-0 px-4 py-2 ${currentScores.equifaxPresentage >= 0 ? 'text-success' : 'text-danger'}  badge ${currentScores.equifaxPresentage >= 0 ? 'bg-success' : 'bg-danger'}  bg-opacity-25`}>
                              <span style={{ fontSize: '16px', fontWeight: '300' }}>
                                {' '}
                                {currentScores.equifaxPresentage >= 0 ? <Triangle size='10' fill='currentColor' className='me-2' /> : <Triangle size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {Math.abs(currentScores.equifaxPresentage)}%
                              </span>
                            </div>
                          )}
                        </div>
                        {currentScores.equifax_label !== 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div>
                              <span style={{ fontSize: '0px', display: 'inline-flex', margin: 'auto 1rem' }} className={`bg-${getScoreColor[currentScores.equifax_label]} p-1 rounded-circle mx-auto me-2`}></span>
                            </div>
                            <div className='text-normal-16 fw-light'>{currentScores.equifax_label}</div>
                          </div>
                        )}
                        {currentScores.equifax_label === 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div className='text-normal-16 fw-light'>No Credit Score</div>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={12} md={4}>
                    <Card className='border-0 rounded-3 shadow mb-md-0 mb-3'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Experian</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {currentScores.experian && currentScores.experian < 350 ? 'N/A' : currentScores.experian || 0}
                          </div>
                          {currentRound >= 2 && (
                            <div className={`d-flex my-auto me-0 px-4 py-2 ${currentScores.experianPresentage >= 0 ? 'text-success' : 'text-danger'} badge ${currentScores.experianPresentage >= 0 ? 'bg-success' : 'bg-danger'} bg-opacity-25`}>
                              <span style={{ fontSize: '16px', fontWeight: '300' }}>
                                {' '}
                                {currentScores.experianPresentage >= 0 ? <Triangle size='10' fill='currentColor' className='me-2' /> : <Triangle size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />}
                                {Math.abs(currentScores.experianPresentage)}%
                              </span>
                            </div>
                          )}
                        </div>
                        {currentScores.experian_label !== 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div>
                              <span style={{ fontSize: '0px', display: 'inline-flex', margin: 'auto 1rem' }} className={`bg-${getScoreColor[currentScores.experian_label]} p-1 rounded-circle mx-auto me-2`}></span>
                            </div>
                            <div className='text-normal-16 fw-light'>{currentScores.experian_label}</div>
                          </div>
                        )}
                        {currentScores.experian_label === 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div className='text-normal-16 fw-light'>No Credit Score</div>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={12} md={4}>
                    <Card className='border-0 rounded-3 shadow mb-md-0 mb-3'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>TransUnion</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {currentScores.transunion && currentScores.transunion < 350 ? 'N/A' : currentScores.transunion || 0}
                          </div>
                          {currentRound >= 2 && (
                            <div className={`d-flex my-auto me-0 px-4 py-2 ${currentScores.transunionPresentage >= 0 ? 'text-success' : 'text-danger'} badge ${currentScores.transunionPresentage >= 0 ? 'bg-success' : 'bg-danger'} bg-opacity-25`}>
                              <span style={{ fontSize: '16px', fontWeight: '300' }}>
                                {' '}
                                {currentScores.transunionPresentage >= 0 ? <Triangle size='10' fill='currentColor' className='me-2' /> : <Triangle size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />}
                                {Math.abs(currentScores.transunionPresentage)}%
                              </span>
                            </div>
                          )}
                        </div>
                        {currentScores.transunion_label !== 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div>
                              <span style={{ fontSize: '0px', display: 'inline-flex', margin: 'auto 1rem' }} className={`bg-${getScoreColor[currentScores.transunion_label]} p-1 rounded-circle mx-auto me-2`}></span>
                            </div>
                            <div className='text-normal-16 fw-light'>{currentScores.transunion_label}</div>
                          </div>
                        )}
                        {currentScores.transunion_label === 'NO CREDIT SCORE' && (
                          <div className='d-flex'>
                            <div className='text-normal-16 fw-light'>No Credit Score</div>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className='mt-3 align-items-stretch'>
                  <Col xs='12' md='6' lg='4' className='mb-0'>
                    <div className='d-flex align-items-center justify-content-between mb-3' style={{ height: '36px' }}>
                      <h3>Credit Enhancement Tools</h3>
                      <div className='py-1 px-3'></div>
                    </div>

                    {credit_enhancement_tool && Object.keys(credit_enhancement_tool).length > 0 ? (
                      <div className='d-flex flex-column'>
                        {Object.keys(credit_enhancement_tool).map(key => {
                          return (
                            <Card key={key} className='border-0 shadow rounded-3 d-flex flex-column mb-3 p-2'>
                              <Card.Body className='px-4 py-3'>
                                <div className='d-flex flex-row justify-content-start gap-1'>
                                  <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{credit_enhancement_tool[key].description}</div>} />
                                  <span className='text-primary me-2' style={{ fontSize: '14px' }}>
                                    {credit_enhancement_tool[key].label}
                                  </span>
                                </div>

                                <div className='d-flex justify-content-between align-items-center'>
                                  <div>
                                    <div className='text-light-gray fw-light'>Potential Score Increase</div>
                                    <div className='fw-semibold fs-18 text-dark-blue'>
                                      {credit_enhancement_tool[key].point >= 0 ? '+' : '-'}
                                      {Math.abs(credit_enhancement_tool[key].point)} Points
                                    </div>
                                  </div>
                                  <Link to='/credit-builder' className='d-flex my-auto me-0 justify-content-center align-items-center bg-primary bg-opacity-10 rounded text-primary' style={{ height: '40px', width: '40px' }}>
                                    <Triangle size='15' fill='currentColor' className='m-auto' style={{ transform: 'rotate(90deg)' }} />
                                  </Link>
                                </div>
                              </Card.Body>
                            </Card>
                          );
                        })}
                      </div>
                    ) : (
                      <Card>
                        <Card.Body className='py-2'>No Data found</Card.Body>
                      </Card>
                    )}
                  </Col>
                  <Col className='overflow-auto order-first order-lg-last mb-5 mb-lg-0'>
                    <CountdownClock date={currentScores.round_end_date} notyf={notyf} currentRound={currentRound} currentStatus={currentStatusData.current_status} />
                    <CurrentProcess cpData={cpData} handleChartYearChange={handleChartYearChange} year={historyYear} />
                  </Col>
                  <Col md='6' className='d-block d-lg-none'>
                    <div className='d-flex align-items-center justify-content-between mt-4 mb-3' style={{ height: '36px' }}>
                      <h3>Credit Summary</h3>
                      <div className='py-1 px-3'></div>
                    </div>
                    <CreditSummary title='Total Revolving Accounts' popover={'Revolving Accounts are associated with the Credit Cards and Secured Cards Reporting on your reports! Revolving Accounts allow you to use any available balance you have to make purchases now, giving you the ability to pay that money back later!'} icon={Pages} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_revolving_accounts : 0} />
                    <CreditSummary title='Total Installment Accounts' popover={'Installment Accounts are associated with Loans such as student loans, auto loans, home loans , and personal loans. Installment Accounts allow you to borrow a lump sum of money , as long as you pay it back on a monthly basis. '} icon={Installment} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_installment_accounts : 0} />
                    <CreditSummary title='Credit Utilization' popover={'Revolving Accounts help paint a picture of your spending habits! Having your Credit Utilization Percentage higher than 30% could be limiting how high your credit score can actually be! The lower your Credit Utilization, the better your score will be!'} icon={Dollar} value={`${creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.credit_utilization_percentage : 0}%`} />
                    <CreditSummary title='Total Positive Accounts' popover={'If an account on your credit report has reported no derogatory information, it will be considered a positive account. Positive accounts may be open or closed, but the point is that they are reporting positive payment history which ultimately benefits your credit score!'} icon={Bull} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_positive_count : 0} />
                    <CreditSummary title='Total Negative Accounts' popover={'Negative Accounts are your Credit Scores worst enemy! Negative accounts are usually the leading cause of low credit scores and denials from lenders when attempting to obtain new credit! Luckily you have Dispute.Ly to help you dispute these negative accounts!'} icon={Bear} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_negative_count : 0} />
                    <CreditSummary title='Start of credit history' popover={"Do you know when exactly you started building credit? By looking at the date of your oldest opened account, you'll be able to identify the point at which you started developing your credit score (based on what the credit report provides). Every month that passes, you add one more month to your payment history. Make sure you are adding payment history now that you will be proud of in the future!"} icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.start_of_credit_history : 'NA'} />
                    <CreditSummary title='Total Ontime Payments' popover={'Lets shift focus to some of your Credit achievements ! Ever wondered how many Total on time payments you have made since you started utilizing your credit? The more on time payments you report, the better credit history you are establishing for yourself! Make future you proud by being on time on all your accounts every month!'} icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_ontime_payment_count : '0'} />
                    <CreditSummary title='Current Credit Rating' popover={'With many factors composing your overall credit scores, Dispute.Ly has given you a Rating to better understand where you currently stand! We will also provide you with the tools, resources, and information you need to get your Credit Rating as high as possible! Everyone should aim for an A+ Credit Rating'} icon={Star} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.current_credit_rating : 'NA'} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col lg='3' className='d-none d-lg-block'>
            <Card className='border-0 rounded-3 shadow mb-0 h-100 d-flex flex-column h-100'>
              <Card.Body className='p-4 d-flex flex-column'>
                <CreditSummary title='Total Revolving Accounts' popover={'Revolving Accounts are associated with the Credit Cards and Secured Cards Reporting on your reports! Revolving Accounts allow you to use any available balance you have to make purchases now, giving you the ability to pay that money back later!'} icon={Pages} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_revolving_accounts : 0} />
                <CreditSummary title='Total Installment Accounts' popover={'Installment Accounts are associated with Loans such as student loans, auto loans, home loans , and personal loans. Installment Accounts allow you to borrow a lump sum of money , as long as you pay it back on a monthly basis. '} icon={Installment} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_installment_accounts : 0} />
                <CreditSummary title='Credit Utilization' popover={'Revolving Accounts help paint a picture of your spending habits! Having your Credit Utilization Percentage higher than 30% could be limiting how high your credit score can actually be! The lower your Credit Utilization, the better your score will be!'} icon={Dollar} value={`${creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.credit_utilization_percentage : 0}%`} />
                <CreditSummary title='Total Positive Accounts' popover={'If an account on your credit report has reported no derogatory information, it will be considered a positive account. Positive accounts may be open or closed, but the point is that they are reporting positive payment history which ultimately benefits your credit score!'} icon={Bull} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_positive_count : 0} />
                <CreditSummary title='Total Negative Accounts' popover={'Negative Accounts are your Credit Scores worst enemy! Negative accounts are usually the leading cause of low credit scores and denials from lenders when attempting to obtain new credit! Luckily you have Dispute.Ly to help you dispute these negative accounts!'} icon={Bear} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_negative_count : 0} />
                <CreditSummary title='Start of credit history' popover={"Do you know when exactly you started building credit? By looking at the date of your oldest opened account, you'll be able to identify the point at which you started developing your credit score (based on what the credit report provides). Every month that passes, you add one more month to your payment history. Make sure you are adding payment history now that you will be proud of in the future!"} icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.start_of_credit_history : 'NA'} />
                <CreditSummary title='Total Ontime Payments' popover={'Lets shift focus to some of your Credit achievements ! Ever wondered how many Total on time payments you have made since you started utilizing your credit? The more on time payments you report, the better credit history you are establishing for yourself! Make future you proud by being on time on all your accounts every month!'} icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_ontime_payment_count : '0'} />
                <CreditSummary title='Current Credit Rating' popover={'With many factors composing your overall credit scores, Dispute.Ly has given you a Rating to better understand where you currently stand! We will also provide you with the tools, resources, and information you need to get your Credit Rating as high as possible! Everyone should aim for an A+ Credit Rating'} icon={Star} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.current_credit_rating : 'NA'} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Dashboard;
